import { CertificateProperties } from 'lib/models/certificates.response';
import { ECertificateDeliveryMethod } from './certificate-form.const';
import {
  TCertificateForm,
  TCertificateRequestData,
} from './certificate-form.types';

export const prepareCertificateData = (
  data: TCertificateForm,
  certificates: Array<CertificateProperties>,
): TCertificateRequestData => {
  const {
    deliveryDate,
    deliveryMethod,
    fromEmail,
    message,
    toEmail,
    total,
    recaptcha,
  } = data;
  const isEmailDeliveryType =
    deliveryMethod === ECertificateDeliveryMethod.email;

  return {
    amount: Number(total),
    deliveryMethod,
    fromEmail,
    message,
    recaptcha,
    deliveryDate:
      isEmailDeliveryType && deliveryDate ? deliveryDate : undefined,
    toEmail: isEmailDeliveryType ? toEmail : undefined,
  };
};

export const formatNumericString = (amount: string): string => {
  return (parseInt(amount) || 0).toLocaleString('ru-RU', {
    maximumFractionDigits: 0,
  });
};
